'use client';
import React, { useEffect } from 'react';

import loadBackgroudImages from '../../common/loadBackgroudImages';

function Header() {
  useEffect(() => {
    loadBackgroudImages();
  }, []);

  return (
    <header
      id="home"
      className=" main-header bg-img valign"
      data-background="/assets/imgs/header/hero-bg.png"
      data-overlay-dark="7"
      style={{ position: 'relative' }}
    >
      <div className="container ontop">
        <div className="row">
          <div className="col-lg-10">
            <div className="caption">
              <h2
                className="hero-headline"
                style={{ fontSize: 'clamp(2rem, 5vw, 3.4rem)', lineHeight: 1.15 }}
              >
                Marketing, conteúdo e estratégia para marcas que querem{' '}
                <span className="main-color">crescer com direção.</span>
              </h2>
              <div className="text mt-30">
                <p
                  className="hero-subheadline"
                  style={{ fontSize: 'clamp(1rem, 2.5vw, 1.25rem)', lineHeight: 1.6, maxWidth: '780px' }}
                >
                  A Hanzol é uma agência de marketing e publicidade que estrutura{' '}
                  <span className="text-light fw-600">posicionamento</span>,
                  executa campanhas e transforma comunicação em resultado.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-80">
          <div className="col-lg-12">
            <div
              className="hero-buttons d-flex flex-wrap"
              style={{ gap: '20px' }}
            >
              <a
                href="https://wa.me/553198550500"
                target="_blank"
                rel="noreferrer"
                className="butn butn-md butn-bg main-colorbg radius-5"
                style={{ color: '#000' }}
              >
                <span className="text" style={{ color: '#000' }}>
                  Quero estruturar minha marca
                </span>
              </a>
              <a
                href="https://wa.me/553198550500"
                target="_blank"
                rel="noreferrer"
                className="butn butn-md butn-bord radius-5"
              >
                <span className="text">Falar com especialista</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '180px',
          background:
            'linear-gradient(to bottom, rgba(15,15,15,0) 0%, #0f0f0f 100%)',
          pointerEvents: 'none',
          zIndex: 2,
        }}
      ></div>
    </header>
  );
}

export default Header;
